import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        user: false,
        permissions: {},
        settings: false,
        loading: {
            states: {
                main: true,
                entity: true,
                newUser: true,
                form: true,
                file: true,
                details: true,
                password: true,
                reply: true,
            },
            sections: {
                main: 0,
                entity: 0,
                newUser: 0,
                form: 0,
                file: 0,
                details: 0,
                password: 0,
                reply: 0,
            }
        },
        savedFilters: false,
        filters: {},
    },
    mutations: {
        setSettings(state, data) {
            state.settings = data;
        },
        login(state, response) {
            state.user = response.user;
            state.permissions = response.user.role.permissions;
            localStorage.setItem('token', response.token);
            window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.token;
        },
        logout(state) {
            axios.post('api/auth/logout').then(function () {
                state.user = false;
            });
            delete window.axios.defaults.headers.common.Authorization;
            localStorage.removeItem('token');
        },
        setUser(state) {
            if (localStorage.getItem('token')) {
                axios.get('api/auth/user').then(function (response) {
                    state.user = response.data;
                    state.permissions = response.data.role.permissions;
                });
            }
        },
        updateUser(state, response) {
            state.user = response;
            state.permissions = response.role.permissions;
        },
        loadSections(state, sections = "main") {
            sections = sections.split(",");
            for (let i = 0; i < sections.length; i++) {
                const section = sections[i];
                state.loading.sections[section]++;
                if (state.loading.sections[section] >= 1) {
                    state.loading.states[section] = true;
                }
            }
        },
        unloadSections(state, sections = "main") {
            sections = sections.split(",");
            for (let i = 0; i < sections.length; i++) {
                const section = sections[i];
                state.loading.sections[section]--;
                if (state.loading.sections[section] <= 0) {
                    state.loading.sections[section] = 0;
                    state.loading.states[section] = false;
                }
            }
        },
        setLoadingDefault(state, section = "main", value = true) {
            state.loading.states[section] = value;
        },
        resetLoading(state) {
            Object.keys(state.loading.states).forEach((key) => {
                state.loading.states[key] = true;
            });
            Object.keys(state.loading.sections).forEach((key) => {
                state.loading.sections[key] = 0;
            });
        },
        saveFilters(state, filters) {
            state.savedFilters = true;
            state.filters = filters;
        },
        resetFilters(state) {
            state.savedFilters = false;
        }
    }
});

export default store;

